import React from "react";
import { Carousel, Typography, Card } from "antd";
import ProductCard from "./ProductCard";

const TrendingSection = ({ isMobile, categories }) => {
  return (
    <div className="py-5 md:py-10">
      <div className="flex justify-center">
        <p
          level={2}
          className="text-center mb-5 md:mb-8 uppercase border-b border-[#d7d4d4] text-xl md:text-2xl font-semibold leading-[28px] md:leading-[34px]"
        >
          TRENDING
        </p>
      </div>
      <Carousel
        dots={false}
        arrows
        slidesToShow={4}
        draggable={true}
        responsive={[
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
        ]}
      >
        {categories?.map((category, index) => (
          <div key={index} className="px-2 cursor-pointer">
            <ProductCard
              height={isMobile ? 350 : 500}
              name={<p className="font-semibold">{category.name}</p>}
              description={"Unstitched Winter ’24 New Arrivals"}
              price={1200}
              id={category.id}
              image={category.image}
              addToBag={true}
              navigateLink={`/product/${category.id}`}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default TrendingSection;
